module.exports = __webpack_public_path__ + "img/9788992053570.8f51c85f.jpg";